import { LRParser, LocalTokenGroup } from '@lezer/lr';
import { syntaxTree, LRLanguage, indentNodeProp, delimitedIndent, foldNodeProp, LanguageSupport } from '@codemirror/language';
import { styleTags, tags } from '@lezer/highlight';
import { linter } from '@codemirror/lint';
import { insertCompletionText } from '@codemirror/autocomplete';
import { StateField } from '@codemirror/state';
import { showTooltip, hoverTooltip, EditorView } from '@codemirror/view';

// @ts-ignore
const t = {
    deserialize: (str) => str,
};

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_word = {__proto__:null,true:92, TRUE:94, false:96, FALSE:98, null:100, NULL:102, starts:112, with:114, ends:116, contains:118, matches:120, not:122, in:124, and:126, or:128, xor:130};
const spec_Operator = {__proto__:null,"?":111, "!":133, "+":135, "-":137};
const parser = LRParser.deserialize({
  version: 14,
  states: ")rOYQPOOP!^OPOOQ!cQPOOO#aQPO'#CeO$tQPO'#CnO${QPO'#CoOYQPO'#CuOYQPO'#CwOOQO'#DS'#DSO%SQPO'#CdO%XQPO'#CdOOQO'#Cl'#ClOOQO'#Cm'#CmOOQO'#Cv'#CvP%^OQO'#C]POOO)C>r)C>rO%iQPO,58yOYQPO,58}OYQPO,59_OYQPO,59]O%nQPO'#CtOOQO'#Ct'#CtO%sQPO'#CtO&zQPO,59YOOQO,59Y,59YO'RQPO'#DYO'`QPO,59ZO'eQPO,59aO'{QPO,59cO(SQPO'#CfOOQO,59O,59OO(SQPO'#CiPOOO'#Cx'#CxP(ZOQO,58wPOOO,58w,58wO(fQPO'#CbOOQO1G.e1G.eOOQO1G.m1G.mO)yQPO1G.iO*QQPO1G.yO*hQPO1G.wOOQO,59`,59`OYQPO1G.tOYQPO'#CyO*oQPO,59tOOQO1G.u1G.uOOQO1G.}1G.}O*zQPO,59QO+PQPO,59TPOOO-E6v-E6vPOOO1G.c1G.cOOQO7+$T7+$TOYQPO7+$cO+UQPO7+$`O+`QPO,59eOOQO-E6w-E6wOOQO1G.l1G.lOOQO1G.o1G.oO+mQPO<<G}OYQPO'#CzO,TQPO<<GzOOQO<<Gz<<GzO,]QPO,59fOOQO-E6x-E6xOOQOAN=fAN=fOYQPO1G/QO,dQPO7+$l",
  stateData: ",v~OqOSrPQ~O^WO_WOwROyTO{VO!OZO!PZO!QZO!RZO!S[O!T[O!VSO!_]O!d]O!e]O!f]O~Or^O~OS`OT`OfbOyaO!XcO!YdO![dO!]eO!^eO!_fO!`eO!aeO!beO!ceO~OSdXTdXfdXodXydX{XX!XdX!YdX![dX!]dX!^dX!_dX!`dX!adX!bdX!cdX!WdXxdX}dXzdX!UdX~O!UhO~PYOx|P~PYO{mO~O{oO~OspOtpOurO~OwsO~O!ZyO~O!`yO^hX_hXwhXyhX{hX!OhX!PhX!QhX!RhX!ShX!ThX!VhX!_hX!dhX!ehX!fhX~O!WzO~P!cO}{Ox|Xz|X~P!cOx}O~Ooia!Wiaxia}iazia!Uia~P!cOz!OO~P!cOz|P~PYOspOtpOu!SO~OSUXTUXfUXoUXyUX{[X!XUX!YUX![UX!]UX!^UX!_UX!`UX!aUX!bUX!cUX!WUXxUX}UXzUX!UUX~Ox!TO~P!cOogi!Wgixgi}gizgi!Ugi~P!cO!W!UO~P!cO}{Ox|az|a~Oz!YO~Oz!ZO~O}!]O!U!_O~P!cOxma}mazma~P!cOoey!Weyxey}eyzey!Uey~P!cO}!]O!U!bO~O!W!cO~P!cO}nq!Unq~P!cO_TfS^wS~",
  goto: "%l}P!OP!RPP!d!R!R!g!x!{#^#aPP!R!R!R!R!R!RP!R#d!R#s!R$U$[$bPPPPPPP$hPPPPP%cR_PoWOSTUVabcmoz{!U!]!cRt`oXOSTUVabcmoz{!U!]!cRnXoYOSTUVabcmoz{!U!]!cRu`RnYkbQgiklvwx!V!W![!`!doUOSTUVabcmoz{!U!]!cQq^R!RqQ|iR!X|Q!^!VR!a!^QQOQgSUiTmoQkUQlVQvaQwbQxcQ!VzQ!W{Q![!UQ!`!]R!d!cQjTQ!PmR!Qo",
  nodeNames: "⚠ BlockComment Expression ObjectAccess MemberOf NullSafeMemberOf Property ArrayAccess Call Function Arguments ObjectAccess Method Arguments Number String Boolean Null Object Array Variable TernaryExpression Operator BinaryExpression OperatorKeyword UnaryExpression UnaryOperator Application",
  maxTerm: 68,
  nodeProps: [
    [t, 14,"number",15,"string",16,"bool",17,"null"]
  ],
  skippedNodes: [0,1,28],
  repeatNodeCount: 3,
  tokenData: "-a~RqXY#YYZ#Y]^#Ypq#Yqr#krs$Quv#{vw%zwx&Sxy'wyz'|z{(R{|#{|}(Z}!O#{!O!P(`!P!Q(h!Q![(u![!]+[!^!_+a!_!`+l!`!a+r!a!b+}!c!},b!}#O,s#P#Q,x#Q#R#{#R#S,b#T#o,b#o#p,}#p#q-S#q#r-[#r#s#{~#_Sq~XY#YYZ#Y]^#Ypq#Y~#pPf~!_!`#s~#xPf~!_!`#{~$QOf~~$TXOr$Qrs$ps#O$Q#O#P$u#P;'S$Q;'S;=`%t<%l~$Q~O$Q~~$p~$uO_~~$xRO;'S$Q;'S;=`%R;=`O$Q~%UYOr$Qrs$ps#O$Q#O#P$u#P;'S$Q;'S;=`%t;=`<%l$Q<%l~$Q~O$Q~~$p~%wP;=`<%l$Q~&PPf~vw#{~&VXOw&Swx$px#O&S#O#P&r#P;'S&S;'S;=`'q<%l~&S~O&S~~$p~&uRO;'S&S;'S;=`'O;=`O&S~'RYOw&Swx$px#O&S#O#P&r#P;'S&S;'S;=`'q;=`<%l&S<%l~&S~O&S~~$p~'tP;=`<%l&S~'|O{~~(ROz~~(WPf~z{#{~(`O}~~(ePS~!O!P#{~(mPf~z{(p~(uOr~~(zT^~!O!P)Z!Q![(u!g!h*Z#R#S+U#X#Y*Z~)^SO!O)j!P;'S)j;'S;=`+O<%lO)j~)oR^~!Q![)x!g!h*Z#X#Y*Z~)}S^~!Q![)x!g!h*Z#R#S*x#X#Y*Z~*^R{|*g}!O*g!Q![*m~*jP!Q![*m~*rQ^~!Q![*m#R#S*g~*{P!Q![)x~+RP;=`<%l)j~+XP!Q![(u~+aO!W~~+fQf~!^!_#{!_!`#{~+oP!_!`#s~+wQf~!_!`#{!`!a#{~,SRf~!O!P,]![!]#{!a!b#{~,bOT~~,gSw~!Q![,b!c!},b#R#S,b#T#o,b~,xOy~~,}Ox~~-SO!V~~-XPf~#p#q#{~-aO!U~",
  tokenizers: [1, new LocalTokenGroup("j~RQYZXz{^~^Ot~~aP!P!Qd~iOu~~", 25, 35)],
  topRules: {"Expression":[0,2]},
  specialized: [{term: 39, get: (value) => spec_word[value] || -1},{term: 22, get: (value) => spec_Operator[value] || -1}],
  tokenPrec: 536
});

var ELScalar;
(function (ELScalar) {
    ELScalar["Bool"] = "bool";
    ELScalar["Number"] = "number";
    ELScalar["String"] = "string";
    ELScalar["Null"] = "null";
    ELScalar["Any"] = "any";
})(ELScalar || (ELScalar = {}));

const createInfoElement = (html) => {
    const dom = document.createElement("div");
    dom.innerHTML = html;
    dom.className = 'cm-diagnostic';
    return dom;
};
function resolveFunctionDefinition(node, state, config) {
    var _a;
    if (!node) {
        return undefined;
    }
    let identifier;
    if (node.name === 'ObjectAccess' && node.lastChild) {
        const leftArgument = (_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.node;
        const types = Array.from(resolveTypes(state, leftArgument, config));
        identifier = state.sliceDoc(node.lastChild.from, node.lastChild.to);
        return types.map(type => { var _a; return resolveCallable(identifier, (_a = config.types) === null || _a === void 0 ? void 0 : _a[type]); }).find(x => x);
    }
    else if (node.name === 'Function') {
        identifier = state.sliceDoc(node.from, node.node.firstChild ? node.node.firstChild.from - 1 : node.to);
        return resolveCallable(identifier, config);
    }
}
const resolveCallable = (identifier, config) => { var _a; return (_a = config === null || config === void 0 ? void 0 : config.functions) === null || _a === void 0 ? void 0 : _a.find(x => x.name === identifier); };
const resolveIdentifier = (nodeName, identifier, config) => {
    var _a;
    switch (nodeName) {
        case 'Method':
        case 'Function':
            return resolveCallable(identifier, config);
        case 'Property':
        case 'Variable':
            return (_a = config === null || config === void 0 ? void 0 : config.identifiers) === null || _a === void 0 ? void 0 : _a.find(x => x.name === identifier);
    }
};
function resolveTypes(state, node, config, matchExact) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let types = new Set();
    if (!node) {
        return types;
    }
    let type;
    if (typeof (type = node.type.prop(t)) !== "undefined") {
        types.add(type);
    }
    else if (node.name === 'Call' && node.firstChild && node.lastChild) {
        resolveTypes(state, node.firstChild, config).forEach(x => types.add(x));
    }
    else if (node.name === 'Variable') {
        const varName = state.sliceDoc(node.from, node.to) || '';
        // @ts-ignore
        (_b = (_a = resolveIdentifier(node.name, varName, config)) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.forEach((x) => types.add(x));
    }
    else if (node.name === 'Function') {
        const varName = state.sliceDoc(node.from, node.to) || '';
        // @ts-ignore
        (_d = (_c = resolveIdentifier(node.name, varName, config)) === null || _c === void 0 ? void 0 : _c.returnType) === null || _d === void 0 ? void 0 : _d.forEach((x) => types.add(x));
    }
    else if (node.name === 'ObjectAccess' && node.firstChild && ((_e = node.lastChild) === null || _e === void 0 ? void 0 : _e.name) === 'Property') {
        const varName = state.sliceDoc(node.lastChild.from, node.lastChild.to) || '';
        (_f = resolveTypes(state, node.firstChild, config)) === null || _f === void 0 ? void 0 : _f.forEach(baseType => {
            var _a, _b, _c, _d;
            // @ts-ignore
            (_d = (_c = resolveIdentifier((_a = node.lastChild) === null || _a === void 0 ? void 0 : _a.name, varName, (_b = config.types) === null || _b === void 0 ? void 0 : _b[baseType])) === null || _c === void 0 ? void 0 : _c.type) === null || _d === void 0 ? void 0 : _d.forEach((x) => types.add(x));
        });
    }
    else if (node.name === 'ObjectAccess' && node.firstChild && ((_g = node.lastChild) === null || _g === void 0 ? void 0 : _g.name) === 'Method') {
        const varName = state.sliceDoc(node.lastChild.from, node.lastChild.to) || '';
        (_h = resolveTypes(state, node.firstChild, config)) === null || _h === void 0 ? void 0 : _h.forEach(baseType => {
            var _a, _b, _c, _d;
            // @ts-ignore
            (_d = (_c = resolveIdentifier((_a = node.lastChild) === null || _a === void 0 ? void 0 : _a.name, varName, (_b = config.types) === null || _b === void 0 ? void 0 : _b[baseType])) === null || _c === void 0 ? void 0 : _c.returnType) === null || _d === void 0 ? void 0 : _d.forEach((x) => types.add(x));
        });
    }
    else if (node.name === 'Application' && node.firstChild) {
        resolveTypes(state, node.firstChild, config).forEach(x => types.add(x));
    }
    else if (node.name === 'TernaryExpression' && node.firstChild && node.firstChild.nextSibling && node.firstChild.nextSibling.nextSibling) {
        resolveTypes(state, node.firstChild.nextSibling, config).forEach(x => types.add(x));
        resolveTypes(state, node.firstChild.nextSibling.nextSibling, config).forEach(x => types.add(x));
    }
    else if (node.name === 'BinaryExpression' && ((_j = node.firstChild) === null || _j === void 0 ? void 0 : _j.nextSibling) && ((_l = (_k = node.firstChild) === null || _k === void 0 ? void 0 : _k.nextSibling) === null || _l === void 0 ? void 0 : _l.nextSibling)) {
        const operator = state.sliceDoc(node.firstChild.nextSibling.from, node.firstChild.nextSibling.to);
        if (operator == '?:' || operator == '??' || operator == '?') {
            if (operator == '?:' || operator == '??') {
                resolveTypes(state, node.firstChild, config).forEach(x => types.add(x));
            }
            resolveTypes(state, node.firstChild.nextSibling.nextSibling, config).forEach(x => types.add(x));
        }
        else if (['||', '&&', '==', '!=', '===', '!==', '>=', '<=', '>', '<'].includes(operator) || keywords.find(x => x.name == operator)) {
            types.add(ELScalar.Bool);
        }
        else if (['**', '|', '^', '&', '<<', '>>', '+', '-', '*', '/', '%'].includes(operator)) {
            types.add(ELScalar.Number);
        }
    }
    else if (node.name === 'UnaryExpression' && node.firstChild) {
        const operator = state.sliceDoc(node.firstChild.from, node.firstChild.to);
        if (['not', '!'].includes(operator)) {
            types.add(ELScalar.Bool);
        }
        else if (['+', '-'].includes(operator)) {
            types.add(ELScalar.Number);
        }
    }
    if (types.size === 0) {
        types.add(ELScalar.Any);
    }
    return types;
}
function getExpressionLanguageConfig(state) {
    return state.languageDataAt('expressionLanguageConfig', 0)[0];
}
const keywords = [
    { name: 'starts with', info: 'Check if a string starts with a specific string' },
    { name: 'ends with', info: 'Check if a string ends with a specific string' },
    { name: 'contains', info: 'Check if a string is not included in another string' },
    { name: 'matches', info: 'Check if a string matches a regex pattern' },
    { name: 'not in', info: 'Check if a value is not included in an array' },
    { name: 'in', info: 'Check if a value is included in an array' },
    { name: 'not' },
    { name: 'or' },
    { name: 'and' },
    { name: 'xor' },
];

/**
 * @internal
 */
const expressionLanguageLinterSource = (state) => {
    const config = getExpressionLanguageConfig(state);
    let diagnostics = [];
    syntaxTree(state).cursor().iterate(node => {
        var _a, _b, _c, _d, _e, _f, _g;
        const { from, to, name } = node;
        let identifier;
        switch (name) {
            case '⚠':
                if (state.doc.length === 0 || from === 0) {
                    // Don't show error on empty doc (even though it is an error)
                    return;
                }
                identifier = state.sliceDoc(from, to);
                if (identifier.length === 0) {
                    diagnostics.push({ from, to: (_c = (_b = (_a = node.node.parent) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.to) !== null && _c !== void 0 ? _c : to, severity: 'error', message: `Expression expected` });
                }
                else {
                    const type = /^[a-zA-Z_]+[a-zA-Z_0-9]*$/.test(identifier) ? 'identifier' : 'operator';
                    diagnostics.push({ from, to, severity: 'error', message: `Unexpected ${type} '${identifier}'` });
                }
                return;
            case 'Arguments':
                const args = (_d = resolveFunctionDefinition(node.node.prevSibling, state, config)) === null || _d === void 0 ? void 0 : _d.args;
                if (!args) {
                    return;
                }
                let i = 0;
                let n = node.node.firstChild;
                while (n) {
                    if (n.name !== 'BlockComment' && ++i > args.length) {
                        diagnostics.push({ from: n.from, to: n.to, severity: 'error', message: `Unexpected argument` });
                    }
                    n = n.nextSibling;
                }
                break;
            case 'Property':
            case 'Method':
                const leftArgument = (_f = (_e = node.node.parent) === null || _e === void 0 ? void 0 : _e.firstChild) === null || _f === void 0 ? void 0 : _f.node;
                const types = Array.from(resolveTypes(state, leftArgument, config));
                identifier = state.sliceDoc(from, to);
                if (!types.find(type => { var _a; return resolveIdentifier(name, identifier, (_a = config.types) === null || _a === void 0 ? void 0 : _a[type]); })) {
                    diagnostics.push({ from, to, severity: 'error', message: `${node.name} "${identifier}" not found in ${types.join('|')}` });
                }
                break;
            case 'Variable':
            case 'Function':
                identifier = state.sliceDoc(from, node.node.firstChild ? node.node.firstChild.from - 1 : to);
                if (!resolveIdentifier(name, identifier, config)) {
                    diagnostics.push({ from, to, severity: 'error', message: `${node.node.name} "${identifier}" not found` });
                }
                break;
        }
        if (identifier && ((_g = node.node.parent) === null || _g === void 0 ? void 0 : _g.type.isError)) {
            diagnostics.push({ from, to, severity: 'error', message: `Unexpected identifier "${identifier}"` });
        }
    });
    return diagnostics;
};
const expressionLanguageLinter = linter(view => expressionLanguageLinterSource(view.state));

const autocompleteFunction = (x) => {
    var _a, _b, _c;
    return ({
        label: `${x.name}(${((_b = (_a = x.args) === null || _a === void 0 ? void 0 : _a.map(x => x.name)) === null || _b === void 0 ? void 0 : _b.join(',')) || ''})`,
        apply: (view, completion, from, to) => {
            var _a;
            view.dispatch(Object.assign(Object.assign({}, insertCompletionText(view.state, `${x.name}()`, from, to)), { selection: { anchor: from + x.name.length + (((_a = x.args) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 1 : 2) } }));
        },
        detail: (_c = x.returnType) === null || _c === void 0 ? void 0 : _c.join('|'),
        info: x.info,
        type: "function",
    });
};
const autocompleteIdentifier = (x) => {
    var _a;
    return ({
        label: x.name,
        apply: x.name,
        info: x.info,
        detail: x.detail || ((_a = x.type) === null || _a === void 0 ? void 0 : _a.join('|')),
        type: 'variable',
    });
};
function completeOperatorKeyword(state, config, tree, from, to, explicit) {
    var _a;
    return {
        from,
        to,
        options: (_a = keywords.map(({ name, info, detail }) => ({
            label: name,
            apply: `${name} `,
            info: info,
            detail,
            type: "keyword"
        }))) !== null && _a !== void 0 ? _a : [],
        validFor: (text) => { var _a; return (_a = keywords.some(({ name }) => explicit || name.includes(text))) !== null && _a !== void 0 ? _a : false; },
    };
}
function completeIdentifier(state, config, tree, from, to) {
    var _a, _b;
    const identifiers = (_a = config.identifiers) !== null && _a !== void 0 ? _a : []; //?.filter(({ name }) => explicit || name.toLowerCase().startsWith(text)) ?? [];
    const functions = (_b = config.functions) !== null && _b !== void 0 ? _b : []; //?.filter(({ name }) => explicit || name.toLowerCase().startsWith(text)) ?? [];
    return {
        from,
        to,
        options: [...(identifiers.map(autocompleteIdentifier)), ...(functions.map(autocompleteFunction))],
        validFor: /^[a-zA-Z_]+[a-zA-Z_0-9]*$/,
    };
}
function completeMember(state, config, tree, from, to, explicit) {
    var _a, _b, _c, _d;
    if (((_a = tree.parent) === null || _a === void 0 ? void 0 : _a.name) != 'ObjectAccess' || !tree.parent.firstChild) {
        return null;
    }
    const types = resolveTypes(state, tree.parent.firstChild.node, config);
    if (!(types === null || types === void 0 ? void 0 : types.size)) {
        return null;
    }
    let options = [];
    for (const type of types) {
        const typeDeclaration = (_b = config.types) === null || _b === void 0 ? void 0 : _b[type];
        options.push(...(((_c = typeDeclaration === null || typeDeclaration === void 0 ? void 0 : typeDeclaration.identifiers) === null || _c === void 0 ? void 0 : _c.map(autocompleteIdentifier)) || []), ...(((_d = typeDeclaration === null || typeDeclaration === void 0 ? void 0 : typeDeclaration.functions) === null || _d === void 0 ? void 0 : _d.map(autocompleteFunction)) || []));
    }
    return {
        from,
        to,
        options,
        validFor: /^[a-zA-Z_]+[a-zA-Z_0-9]*$/,
    };
}
function expressionLanguageCompletion(context) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { state, pos, explicit } = context;
    const tree = syntaxTree(state);
    const lastChar = state.sliceDoc(pos - 1, pos);
    const prevNode = tree.resolveInner(pos, lastChar === ')' ? 0 : -1);
    const config = getExpressionLanguageConfig(state);
    const isIdentifier = (node) => { var _a; return ['Variable', 'Function'].includes((_a = node === null || node === void 0 ? void 0 : node.name) !== null && _a !== void 0 ? _a : ''); };
    const isMember = (node) => { var _a; return ['Property', 'Method'].includes((_a = node === null || node === void 0 ? void 0 : node.name) !== null && _a !== void 0 ? _a : ''); };
    if (prevNode.name == 'String' || prevNode.name == 'BlockComment') {
        return null;
    }
    if (((_a = prevNode.parent) === null || _a === void 0 ? void 0 : _a.name) == 'ObjectAccess' && ['ObjectAccess', 'ArrayAccess', 'Variable', 'Call', 'Application'].includes(((_b = prevNode.parent.firstChild) === null || _b === void 0 ? void 0 : _b.name) || '')) {
        return completeMember(state, config, prevNode, isIdentifier(prevNode) || isMember(prevNode) ? prevNode.from : pos, pos);
    }
    if (['Expression', 'UnaryExpression', 'BinaryExpression', 'TernaryExpression'].includes(prevNode.name) && prevNode.lastChild && !((_c = prevNode.lastChild) === null || _c === void 0 ? void 0 : _c.type.isError)
        || ['Arguments', 'Array'].includes(prevNode.name) && prevNode.lastChild && !((_d = prevNode.lastChild) === null || _d === void 0 ? void 0 : _d.type.isError)
        || ['Expression', 'UnaryExpression', 'BinaryExpression', 'TernaryExpression'].includes((_f = (_e = prevNode.parent) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '') && prevNode.type.isError
        || ['Variable', 'Function'].includes((_h = (_g = prevNode.parent) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '') && prevNode.type.isError) {
        return completeOperatorKeyword(state, config, prevNode, !['Expression', 'UnaryExpression', 'BinaryExpression', 'TernaryExpression', 'Arguments'].includes(prevNode.name) ? prevNode.from : pos, pos, explicit);
    }
    if (!/[0-9]/.test(lastChar) && !['OperatorKeyword'].includes((_j = prevNode.name) !== null && _j !== void 0 ? _j : '') && (['Expression', 'UnaryExpression', 'BinaryExpression', 'TernaryExpression'].includes(prevNode.name) && ((_k = prevNode.lastChild) === null || _k === void 0 ? void 0 : _k.type.isError)
        || ['Expression', 'UnaryExpression', 'BinaryExpression', 'TernaryExpression', 'Arguments'].includes((_m = (_l = prevNode.parent) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : '') && !prevNode.type.isError
        || ['Arguments', 'Array'].includes((_o = prevNode.name) !== null && _o !== void 0 ? _o : ''))) {
        return completeIdentifier(state, config, prevNode, isIdentifier(prevNode) ? prevNode.from : pos, pos);
    }
    return null;
}

function getNodeOrdinal(node) {
    let ordinal = -1;
    // noinspection StatementWithEmptyBodyJS
    for (let c = node; c; c = c.prevSibling, ordinal++)
        ;
    return ordinal;
}
function resolveArguments(node) {
    let c = node;
    while (c && c.name !== 'Arguments') {
        c = c.parent;
    }
    return c;
}
function getCursorTooltips(state) {
    const config = getExpressionLanguageConfig(state);
    // @ts-ignore
    return state.selection.ranges
        .filter(range => range.empty)
        .map(range => {
        var _a, _b;
        const tree = syntaxTree(state);
        const node = tree.resolveInner(range.from, 0);
        const args = resolveArguments(node);
        if (!args || !args.prevSibling) {
            return null;
        }
        const fn = resolveFunctionDefinition(args.prevSibling, state, config);
        if (!fn) {
            return null;
        }
        const n = args.childAfter(range.from - 1);
        const argName = (_b = (_a = fn.args) === null || _a === void 0 ? void 0 : _a[n ? getNodeOrdinal(n) : 0]) === null || _b === void 0 ? void 0 : _b.name;
        if (n && n.from !== range.from || !argName) {
            return null;
        }
        return {
            pos: range.head,
            above: true,
            strictSide: false,
            arrow: true,
            create: () => {
                let dom = document.createElement("div");
                dom.className = "cm-tooltip-cursor";
                dom.textContent = `${argName}`;
                return { dom };
            },
        };
    }).filter(x => x);
}
const cursorTooltipField = StateField.define({
    create: (state) => getCursorTooltips(state),
    update(tooltips, tr) {
        if (!tr.docChanged && !tr.selection) {
            return tooltips;
        }
        return getCursorTooltips(tr.state);
    },
    provide: f => showTooltip.computeN([f], state => state.field(f))
});
const keywordTooltip = hoverTooltip((view, pos, side) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const config = getExpressionLanguageConfig(view.state);
    const tree = syntaxTree(view.state).resolveInner(pos, side);
    if (tree.name === 'OperatorKeyword') {
        const name = view.state.sliceDoc(tree.from, tree.to);
        const info = (_a = keywords.find(x => x.name === name)) === null || _a === void 0 ? void 0 : _a.info;
        if (info) {
            return {
                pos: tree.from,
                end: tree.to,
                above: true,
                create: () => ({ dom: createInfoElement(info) }),
            };
        }
    }
    if (!['Function', 'Variable', 'Method', 'Property'].includes(tree.name)) {
        return null;
    }
    const skipEmpty = (x) => x;
    let info;
    if (((_b = tree.parent) === null || _b === void 0 ? void 0 : _b.firstChild) && ((_c = tree.parent) === null || _c === void 0 ? void 0 : _c.name) === 'ObjectAccess' && tree.prevSibling) {
        const node = tree.parent.firstChild;
        const types = Array.from(resolveTypes(view.state, node, config));
        const name = view.state.sliceDoc(tree.from, tree.to);
        info = [
            ...types.map(type => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = config.types) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.identifiers) === null || _c === void 0 ? void 0 : _c.find(x => x.name === name)) === null || _d === void 0 ? void 0 : _d.info; }).filter(skipEmpty),
            ...types.map(type => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = config.types) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.functions) === null || _c === void 0 ? void 0 : _c.find(x => x.name === name)) === null || _d === void 0 ? void 0 : _d.info; }).filter(skipEmpty),
        ].join('\n');
    }
    else {
        const name = view.state.sliceDoc(tree.from, tree.to);
        info = [
            ...[(_e = (_d = config.identifiers) === null || _d === void 0 ? void 0 : _d.find(x => x.name === name)) === null || _e === void 0 ? void 0 : _e.info].filter(skipEmpty),
            ...[(_g = (_f = config.functions) === null || _f === void 0 ? void 0 : _f.find(x => x.name === name)) === null || _g === void 0 ? void 0 : _g.info].filter(skipEmpty),
        ].join('\n');
    }
    if (!info) {
        return null;
    }
    return {
        pos: tree.from,
        end: tree.to,
        above: true,
        create: () => ({ dom: createInfoElement(info) }),
    };
});

const baseTheme = EditorView.baseTheme({
    ".cm-tooltip.cm-tooltip-cursor": {
        boxShadow: 'rgba(0, 0, 0, .15) 0 1px 2px',
        border: "1px solid rgba(127, 127, 127, .2)",
        fontSize: ".85rem",
        padding: ".4rem .5rem",
        borderRadius: "4px",
        "& .cm-tooltip-arrow:before": {},
        "& .cm-tooltip-arrow:after": {
            borderTopColor: "transparent"
        },
    },
    ".cm-tooltip.cm-completionInfo, .cm-diagnostic": {
        boxShadow: "rgba(0, 0, 0, .15) 0 2px 5px",
        fontSize: ".85rem",
        padding: ".8rem !important", // Couldn't figure out other means to override https://github.com/codemirror/autocomplete/blob/6.18.1/src/theme.ts#L65
    },
    ".cm-completionDetail": {
        float: "right",
        opacity: 0.5,
        fontStyle: "inherit !important",
    },
});

const ELLanguage = LRLanguage.define({
    parser: parser.configure({
        props: [
            indentNodeProp.add({
                Application: delimitedIndent({ closing: ")", align: false }),
                Arguments: delimitedIndent({ closing: ")", align: false }),
                Object: delimitedIndent({ closing: "}", align: false }),
            }),
            foldNodeProp.add({
                Application: ({ from, to }) => ({ from: from + 1, to: to - 1 }),
                Arguments: ({ from, to }) => ({ from: from + 1, to: to - 1 }),
                Object: ({ from, to }) => ({ from: from + 1, to: to - 1 }),
            }),
            styleTags({
                Property: tags.propertyName,
                Variable: tags.variableName,
                Function: tags.function(tags.variableName),
                Method: tags.function(tags.propertyName),
                Boolean: tags.bool,
                String: tags.string,
                Number: tags.number,
                '(': tags.paren,
                ')': tags.paren,
                '[': tags.squareBracket,
                ']': tags.squareBracket,
                ',': tags.punctuation,
                MemberOf: tags.punctuation,
                NullSafeMemberOf: tags.punctuation,
                OperatorKeyword: tags.operatorKeyword,
                UnaryOperator: tags.operator,
                Operator: tags.operator,
                BlockComment: tags.comment,
            })
        ]
    }),
    languageData: {},
});
function expressionlanguage(config = {}, extensions = []) {
    return new LanguageSupport(ELLanguage, [
        ELLanguage.data.of({
            autocomplete: expressionLanguageCompletion,
            expressionLanguageConfig: config,
        }),
        expressionLanguageLinter,
        keywordTooltip,
        cursorTooltipField,
        baseTheme,
        ...extensions,
    ]);
}

export { ELLanguage, expressionlanguage };
